import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "bridge-config"
  }, [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('p', {
    staticClass: "card-description my-0"
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.state.description')) + "\n      ")]), _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    ref: "virtualDevice",
    attrs: {
      "disabled": _vm.mode === 'readonly',
      "items": _vm.virtualDevices,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "loading": _vm.loadingDevices,
      "search-input": _vm.virtualDeviceSearch,
      "placeholder": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.niota.devicePlaceholder'),
      "hide-selected": _vm.loadingDevices || !_vm.virtualDeviceSearch || _vm.virtualDeviceSearch.length < 1,
      "hide-no-data": _vm.loadingDevices || !_vm.virtualDeviceSearch || _vm.virtualDeviceSearch.length < 1,
      "no-data-text": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.niota.deviceNoResults'),
      "label": _vm.virtualDeviceSourceName,
      "rules": _vm.mode === 'readonly' ? [] : _vm.requiredRule,
      "item-value": "id",
      "item-text": "title",
      "autocomplete": "off",
      "return-object": "",
      "no-filter": "",
      "hide-details": ""
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.virtualDeviceSearch = $event;
      },
      "update:search-input": function ($event) {
        _vm.virtualDeviceSearch = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n                  " + _vm._s(data.item.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")\n                ")]), _c(VListItemSubtitle, {
          domProps: {
            "innerHTML": _vm._s(_vm.get(data.item, 'properties.bridge.deviceData.device_id'))
          }
        })], 1)];
      }
    }]),
    model: {
      value: _vm.selectedVirtualDevice,
      callback: function ($$v) {
        _vm.selectedVirtualDevice = $$v;
      },
      expression: "selectedVirtualDevice"
    }
  })], 1), _vm.selectedVirtualDevice && _vm.selectedVirtualDevice.id ? _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": `/#/virtual-devices/${_vm.selectedVirtualDevice.id}`,
      "target": "_blank"
    }
  }, [_vm._v("\n            » " + _vm._s(_vm.selectedVirtualDevice.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(_vm.selectedVirtualDevice.id) + ")\n          ")])]) : _vm._e(), _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm.selectedVirtualDevice && _vm.virtualDeviceStates ? _c(VDataTable, {
    attrs: {
      "headers": _vm.virtualDeviceVariableHeaders,
      "footer-props": _vm.virtualDeviceVariableFooterProps,
      "items": _vm.virtualDeviceStates,
      "single-select": _vm.mode !== 'import',
      "item-key": "id",
      "show-select": ""
    },
    scopedSlots: _vm._u([{
      key: "item.value.value",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "text-truncate",
          staticStyle: {
            "width": "140px"
          }
        }, [_vm._v(_vm._s(JSON.stringify(item.value.value)))])];
      }
    }, {
      key: "item.milliseconds_ago",
      fn: function ({
        item
      }) {
        return [_vm._v("\n              " + _vm._s(item.time_ago) + "\n            ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n                " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n              ")])];
      },
      proxy: true
    }], null, false, 1996603903),
    model: {
      value: _vm.selectedVirtualDeviceState,
      callback: function ($$v) {
        _vm.selectedVirtualDeviceState = $$v;
      },
      expression: "selectedVirtualDeviceState"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };